import { render, staticRenderFns } from "./ArticleHeader.vue?vue&type=template&id=47e8f59c&"
import script from "./ArticleHeader.vue?vue&type=script&lang=js&"
export * from "./ArticleHeader.vue?vue&type=script&lang=js&"
import style0 from "./ArticleHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports